// @module ACS.ACSPLPStyles.Main
define('ACS.ACSPLPStyles.Main.View'
,	[
	'acs_acsplpstyles_main.tpl'
	
	,	'ACS.ACSPLPStyles.Main.SS2Model'
	
	,	'Backbone'
    ]
, function (
	acs_acsplpstyles_main_tpl
	
	,	MainSS2Model
	
	,	Backbone
)
{
    'use strict';

	// @class ACS.ACSPLPStyles.Main.View @extends Backbone.View
	return Backbone.View.extend({

		template: acs_acsplpstyles_main_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new MainModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return ACS.ACSPLPStyles.Main.View.Context
	,	getContext: function getContext()
		{
			//@class ACS.ACSPLPStyles.Main.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
